export default function ApproveRejectActions({
  onApprove = () => {},
  onReject,
  showApprove = true,
  approveLabel = 'Approve',
  rejectLabel = 'Reject',
  approveDisabled = false,
  rejectDisabled = false,
  loading = false,
}: { onApprove?: any; onReject: any; showApprove?: boolean; approveLabel?: string; rejectLabel?: string; approveDisabled?: boolean; rejectDisabled?: boolean; loading?: boolean }) {
  return (
    <div className='row gap-3 self-end'>
      <button
        type='button'
        className='btn cta-btn cta-btn--reject'
        onClick={() => onReject?.()}
        disabled={rejectDisabled || loading}
      >
        {rejectLabel}
      </button>

      {showApprove && (
        <button
          type='button'
          className='btn cta-btn cta-btn--approve'
          onClick={() => onApprove?.()}
          disabled={approveDisabled || loading}
        >
          {approveLabel}
        </button>
      )}
    </div>
  );
}
